import React from "react";
import { NumberCount } from "components/common/NumberCount";
import { TabDefinition } from "components/common/TabMenu";
import { TabHeader } from "components/common/TabHeader";
import { Button } from "components/common/Button";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import { FilterDropdown } from "./FilterDropdown";

interface FilterCategoriesState {
  all: boolean;
  requests: boolean;
  updates: boolean;
}

interface NotificationToolbarProps {
  activeFilter: "all" | "unread";
  setActiveFilter: (filter: "all" | "unread") => void;
  unreadCount: number;
  onMarkAllAsRead: () => void;
  markingAllAsRead: boolean;
  filterCategories: FilterCategoriesState;
  showFilterDropdown: boolean;
  onToggleDropdown: () => void;
  onCategoryFilterChange: (category: "all" | "requests" | "updates") => void;
  onCloseDropdown: () => void;
  onOpenSettings?: () => void | Promise<void>;
}

export const NotificationToolbar: React.FC<NotificationToolbarProps> = ({
  activeFilter,
  setActiveFilter,
  unreadCount,
  onMarkAllAsRead,
  markingAllAsRead,
  filterCategories,
  showFilterDropdown,
  onToggleDropdown,
  onCategoryFilterChange,
  onCloseDropdown,
  onOpenSettings,
}) => {
  const tabs: TabDefinition[] = [
    {
      id: "all",
      label: "All",
    },
    {
      id: "unread",
      label: "Unread",
      icon: unreadCount > 0 ? <NumberCount count={unreadCount} /> : undefined,
    },
  ];

  const rightActions: React.ReactNode[] = [];

  rightActions.push(
    <FilterDropdown
      key="filter"
      filterCategories={filterCategories}
      showFilterDropdown={showFilterDropdown}
      onToggleDropdown={onToggleDropdown}
      onCategoryFilterChange={onCategoryFilterChange}
      onClose={onCloseDropdown}
      size="sm"
    />,
  );

  if (onOpenSettings) {
    rightActions.push(
      <Button
        key="settings"
        variant="default"
        size="sm"
        onClick={(e) => {
          e.stopPropagation();
          onOpenSettings();
        }}
      >
        <SettingsOutlinedIcon sx={{ fontSize: 20 }} />
      </Button>,
    );
  }

  return (
    <div className="mb-4">
      <div className="flex flex-col w-full">
        <TabHeader
          tabs={tabs}
          activeTabId={activeFilter}
          onTabChange={(tabId) => setActiveFilter(tabId as "all" | "unread")}
          middleContent={
            unreadCount > 0 ? (
              <button
                onClick={(e) => {
                  e.stopPropagation();
                  onMarkAllAsRead();
                }}
                disabled={markingAllAsRead}
                className="text-accent-medium cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed whitespace-nowrap hover:underline"
              >
                Mark all as read
              </button>
            ) : undefined
          }
          actions={rightActions}
        />
      </div>
    </div>
  );
};
